<template>
  <right-banner-template :title="title">
    <div class="eva-form-content">
      <!-- <p>{{ $store.getters['student/finalEvaluation1'] }} <a href="https://www.google.com/" target="_blank">{{ $store.getters['student/finalEvaluation2']
      }}</a></p> -->
      <p>{{ evaluationLink1 }} <a href="https://docs.google.com/forms/d/e/1FAIpQLSc5bsVSclkzgil_iBQCga3ko-D5ro0PwNFPZp38F3WYOZLthQ/viewform" target="_blank">{{ linkKeyword }}</a></p>
      <p>{{ evaluationLink2 }} <a href="https://docs.google.com/forms/d/e/1FAIpQLSf28a10Sv3bzvfVpjk-pyIFRDFzsq5UBQC5UHxN8dS3uznfKg/viewform" target="_blank">{{ linkKeyword }}</a></p>
    </div>
  </right-banner-template>
</template>

<script>
export default {
  props: ['title'],
  computed: {
    evaluationLink1 () {
      if (this.$store.state.lang === 'vn') {
        return 'Vui lòng thực hiện phiếu đánh giá khóa học (không sử dụng TTBHL chuyên dụng) tại'
      } else {
        return 'Please complete the evaluation form for the training course (without training devices)'
      }
    },
    evaluationLink2 () {
      if (this.$store.state.lang === 'vn') {
        return 'Vui lòng thực hiện phiếu đánh giá khóa học về ATKT tại'
      } else {
        return 'Please complete the evaluation form for the training course in FLT safety operatons'
      }
    },
    linkKeyword () {
      if (this.$store.state.lang === 'vn') {
        return 'đây'
      } else {
        return 'here'
      }
    }
  }
}
</script>

<style scoped>
  .eva-form-content p a{
    color: #006fa9;
    text-decoration: none;
    transition: color 0.2s ease;
    font-weight: bold;
    cursor: pointer;
  }

  .eva-form-content p {
    margin-bottom: 40px;
  }

  p a:hover {
    color: #d23a3a;
  }

</style>
